import skillsReducer from "../skillsReducer";
import niveauSkillReducer from "../niveauSkillReducer";
import niveauCriticiteReducer from "../niveauCriticiteReducer";
import jobSkillReducer from "../jobSkillReducer";
import modeEvaluationReducer from "../modeEvaluationReducer";
import careerPathReducer from "../careerPathReducer";
import careerPathStepReducer from "../careerPathStepReducer";
import employeeCareerPathReducer from "../employeeCareerPathReducer";
import skillEvaluationReducer from "../skillEvaluationReducer";
import peerEvaluationConfigReducer from "../peerEvaluationConfigReducer";

const skillsReducers = {
  skills: skillsReducer,
  niveauSkill: niveauSkillReducer,
  niveauCriticite: niveauCriticiteReducer,
  jobSkill: jobSkillReducer,
  modesEvaluation: modeEvaluationReducer,
  careerPath: careerPathReducer,
  careerPathStep: careerPathStepReducer,
  employeeCareerPath: employeeCareerPathReducer,
  skillEvaluation: skillEvaluationReducer,
  peerEvaluationConfig: peerEvaluationConfigReducer,
};

export default skillsReducers;
